import { apiFetch } from "../utils/apiFetch";

const apiUrl = process.env.REACT_APP_API_URL;

// Fetch list of all Programs
export async function getAllPrograms() {
  const response = await apiFetch(`${apiUrl}/programs`, {
    method: 'GET',
  });
  if (!response.ok) throw new Error('Failed to fetch programs');
  return await response.json();
}

